import React, { useEffect } from 'react';

const watchRouteLoaded = (Component) => {
  return ({ onRouteLoaded, ...props }) => {
    useEffect(() => {
      onRouteLoaded(props);
    }, []);

    return <Component {...props} />;
  };
};

export default watchRouteLoaded;
